const TransactionsActionTypes = {
    START_TRANSACTIONS: 'START_TRANSACTIONS',
    SUCCESS_TRANSACTIONS: 'SUCCESS_TRANSACTIONS',

    START_FILTERING_TRANSACTIONS: 'START_FILTERING_TRANSACTIONS',
    SUCCESS_FILTERING_TRANSACTIONS: 'SUCCESS_FILTERING_TRANSACTIONS',
    FINISHED_FILTERING_TRANSACTIONS: 'FINISHED_FILTERING_TRANSACTIONS',
    ERROR_FILTERING_TRANSACTIONS: 'ERROR_FILTERING_TRANSACTIONS',

    START_ALERT_TRANSACTION: 'START_ALERT_TRANSACTION',
    SUCCESS_ALERT_TRANSACTION: 'SUCCESS_ALERT_TRANSACTION',

    FETCH_PAY_TRANSACTION: 'FETCH_PAY_TRANSACTION',
    SUCCESS_PAY_TRANSACTION: 'SUCCESS_PAY_TRANSACTION',
    FINISH_PAY_TRANSACTION: 'FINISH_PAY_TRANSACTION',

    START_PUT_TRANSACTION_NOTE: 'START_PUT_TRANSACTION_NOTE',
    SUCCESS_PUT_TRANSACTION_NOTE: 'SUCCESS_PUT_TRANSACTION_NOTE',
    FINISH_PUT_TRANSACTION_NOTE: 'FINISH_PUT_TRANSACTION_NOTE',
    ERROR_PUT_TRANSACTION_NOTE: 'ERROR_PUT_TRANSACTION_NOTE',

    START_CANCEL_TRANSACTION: 'START_CANCEL_TRANSACTION',
    SUCCESS_CANCEL_TRANSACTION: 'SUCCESS_CANCEL_TRANSACTION',
    FINISH_CANCEL_TRANSACTION: 'FINISH_CANCEL_TRANSACTION',
    ERROR_CANCEL_TRANSACTION: 'ERROR_CANCEL_TRANSACTION',

    START_COMPLETE_TRANSACTION: 'START_COMPLETE_TRANSACTION',
    SUCCESS_COMPLETE_TRANSACTION: 'SUCCESS_COMPLETE_TRANSACTION',
    FINISH_COMPLETE_TRANSACTION: 'FINISH_COMPLETE_TRANSACTION',
    ERROR_COMPLETE_TRANSACTION: 'ERROR_COMPLETE_TRANSACTION',

    START_FAKE_DEPOSIT: 'START_FAKE_DEPOSIT',
    SUCCESS_FAKE_DEPOSIT: 'SUCCESS_FAKE_DEPOSIT',
    FINISH_FAKE_DEPOSIT: 'FINISH_FAKE_DEPOSIT',
    ERROR_FAKE_DEPOSIT: 'ERROR_FAKE_DEPOSIT',

    START_APPROVE_TRANSACTION: 'START_APPROVE_TRANSACTION',
    SUCCESS_APPROVE_TRANSACTION: 'SUCCESS_APPROVE_TRANSACTION',
    FINISH_APPROVE_TRANSACTION: 'FINISH_APPROVE_TRANSACTION',
    ERROR_APPROVE_TRANSACTION: 'ERROR_APPROVE_TRANSACTION',

    START_DOWNLOAD_PDF_TRANSACTION: 'START_DOWNLOAD_PDF_TRANSACTION',
    SUCCESS_DOWNLOAD_PDF_TRANSACTION: 'SUCCESS_DOWNLOAD_PDF_TRANSACTION',
    FINISH_DOWNLOAD_PDF_TRANSACTION: 'FINISH_DOWNLOAD_PDF_TRANSACTION',
    ERROR_DOWNLOAD_PDF_TRANSACTION: 'ERROR_DOWNLOAD_PDF_TRANSACTION',

    START_GET_PDF_STATEMENT: 'START_GET_PDF_STATEMENT',
    SUCCESS_GET_PDF_STATEMENT: 'SUCCESS_GET_PDF_STATEMENT',
    FINISH_GET_PDF_STATEMENT: 'FINISH_GET_PDF_STATEMENT',
    ERROR_GET_PDF_STATEMENT: 'ERROR_GET_PDF_STATEMENT',

    START_GET_TXT_STATEMENT: 'START_GET_TXT_STATEMENT',
    SUCCESS_GET_TXT_STATEMENT: 'SUCCESS_GET_TXT_STATEMENT',
    FINISH_GET_TXT_STATEMENT: 'FINISH_GET_TXT_STATEMENT',
    ERROR_GET_TXT_STATEMENT: 'ERROR_GET_TXT_STATEMENT',

    START_GET_FILES: 'START_GET_FILES',
    SUCCESS_GET_FILES: 'SUCCESS_GET_FILES',
    FINISH_GET_FILES: 'FINISH_GET_FILES',
    ERROR_GET_FILES: 'ERROR_GET_FILES',

    START_GET_XML_STATEMENT: 'START_GET_XML_STATEMENT',
    SUCCESS_GET_XML_STATEMENT: 'SUCCESS_GET_XML_STATEMENT',
    ERROR_GET_XML_STATEMENT: 'ERROR_GET_XML_STATEMENT',
    FINISH_GET_XML_STATEMENT: 'FINISH_GET_XML_STATEMENT',

    START_GET_CSV_STATEMENT: 'START_GET_CSV_STATEMENT',
    SUCCESS_GET_CSV_STATEMENT: 'SUCCESS_GET_CSV_STATEMENT',
    ERROR_GET_CSV_STATEMENT: 'ERROR_GET_CSV_STATEMENT',
    FINISH_GET_CSV_STATEMENT: 'FINISH_GET_CSV_STATEMENT',

    START_GET_COUNTS: 'START_GET_COUNTS',
    SUCCESS_GET_COUNTS: 'SUCCESS_GET_COUNTS',
    ERROR_GET_COUNTS: 'ERROR_GET_COUNTS',
    FINISH_GET_COUNTS: 'FINISH_GET_COUNTS',

    START_GET_STATUSES: 'START_GET_STATUSES',
    SUCCESS_GET_STATUSES: 'SUCCESS_GET_STATUSES',
    ERROR_GET_STATUSES: 'ERROR_GET_STATUSES',
    FINISH_GET_STATUSES: 'FINISH_GET_STATUSES',
}

export default TransactionsActionTypes
